import { useNuxtApp } from '#app';

export default defineNuxtRouteMiddleware((to, from) => {
  if (process.server) return;

  if (!from.meta.pageTransition || !to.meta.pageTransition) return;

  const nuxtApp = useNuxtApp();
  const menuOpen = useMenuOpen?.();
  const isTransitioning = useTransitioning?.();
  const { $Lenis, $eventBus } = nuxtApp;

  from.meta.pageTransition.onBeforeLeave = () => {
    if (menuOpen && menuOpen.value) {
      $eventBus.emit('closeMenu');
    }
  };

  // Funzione per rimuovere suffissi di lingua dal nome route
  function normalizeRouteName(name) {
    if (!name) return '';
    return name.split('___')[0];
  }

  // Carica l'animazione di EXIT per la pagina che stai lasciando
  const loadExitTransition = async pageName => {
    if (pageName === 'index') {
      return import('~/transitions/indexExit');
    }
    if (pageName === 'works') {
      return import('~/transitions/worksExit');
    }
    if (pageName === 'works-id') {
      return import('~/transitions/worksIdExit');
    }
    return null;
  };

  // Carica l'animazione di ENTER per la pagina dove stai andando
  const loadEnterTransition = async pageName => {
    if (pageName === 'index') {
      return import('~/transitions/indexEnter');
    }
    if (pageName === 'works') {
      return import('~/transitions/worksEnter');
    }
    if (pageName === 'works-id') {
      return import('~/transitions/worksIdEnter');
    }
    return null;
  };

  from.meta.pageTransition.onLeave = (page, done) => {
    $eventBus.emit('page:leave');
    // $Lenis.core.stop();

    const fromName = normalizeRouteName(from.name);
    loadExitTransition(fromName).then(module => {
      if (module) {
        const exitFn = Object.values(module)[0];
        exitFn(page).then(() => {
          done();
        });
      } else {
        done();
      }
    });
  };

  to.meta.pageTransition.onEnter = (page, done) => {
    $eventBus.emit('page:entering');
    $Lenis?.core?.scrollTo(0, { immediate: true });

    const toName = normalizeRouteName(to.name);
    loadEnterTransition(toName).then(module => {
      if (module) {
        const enterFn = Object.values(module)[0];
        enterFn(page).then(() => {
          isTransitioning.value = false;
          $eventBus.emit('page:enter');
          $Lenis?.start();
          $Lenis?.refresh();
          done();
        });
      } else {
        isTransitioning.value = false;
        $eventBus.emit('page:enter');
        $Lenis?.start();
        $Lenis?.refresh();
        done();
      }
    });
  };
});
